// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-select--none {\n  user-select: none; }\n\n.user-select--initial {\n  user-select: initial; }\n\n@media screen and (min-width: 600px) {\n  .drawer-mobile {\n    display: none; } }\n\n.drawer-mobile {\n  z-index: 1000; }\n\n.drawer-mobile nav.main-menu {\n  overflow-y: auto;\n  padding: 8px 8px 0 8px;\n  top: 88px;\n  height: calc(100% - 88px); }\n  .drawer-mobile nav.main-menu .nav-link {\n    width: 100%; }\n", ""]);
// Exports
module.exports = exports;
